export const contactsFilterCategoryMap = {
    contacts: "contacts",
} as const;

export type ContactsFilterCategory = (typeof contactsFilterCategoryMap)[keyof typeof contactsFilterCategoryMap];
